/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.222.1-v202611040101-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqTablesApiClass {
 
   constructor() {}

  /**
   * @summary Export table data as CSV, respecting filters and sorts, up to the requested limit
   * @param {string} tableId - ID of the table
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public exportTableDataCsv(
    body: models.TableDataQueryInputV1,
    {
      tableId
    } : {
      tableId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (tableId === null || tableId === undefined) {
      throw new Error("'tableId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/tables/${encodeURIComponent(String(tableId))}/data/csv`
      .replace('{tableId}', encodeURIComponent(String(tableId)));
    const urlTemplate = `${baseUrl}/tables/{tableId}/data/csv`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Export table data as an Excel workbook, respecting filters and sorts, up to the requested limit. Timestamp columns are written as dates in the requested time zone and durations as [h]:mm:ss.
   * @param {string} tableId - ID of the table
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public exportTableDataXlsx(
    body: models.TableDataQueryInputV1,
    {
      tableId
    } : {
      tableId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (tableId === null || tableId === undefined) {
      throw new Error("'tableId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/tables/${encodeURIComponent(String(tableId))}/data/xlsx`
      .replace('{tableId}', encodeURIComponent(String(tableId)));
    const urlTemplate = `${baseUrl}/tables/{tableId}/data/xlsx`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Return a page of Workbench capsules-pane rows for the supplied conditions.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public queryCapsulesTable(
    body: models.CapsulesTableInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/tables/capsules`;
    const urlTemplate = `${baseUrl}/tables/capsules`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TableResultOutputV1>;
  }

  /**
   * @summary Generate a condition table based on the table specified by id
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public queryConditionTable(
    body: models.ConditionTableInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/tables/condition`;
    const urlTemplate = `${baseUrl}/tables/condition`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TableResultOutputV1>;
  }

  /**
   * @summary Query a simple table in which the rows are items and columns are item properties and formula statistics for those items.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public querySimpleTable(
    body: models.SimpleTableInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/tables/simple`;
    const urlTemplate = `${baseUrl}/tables/simple`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TableResultOutputV1>;
  }

  /**
   * @summary Query a scaling table as a tree structure
   * @param {string} tableId - The id of the table
   * @param {Array<string>} [groupKeys] - Ordered list of node ids identifying the parent; omit for root level
   * @param {number} [offset=0] - Pagination offset — index of the first child to return
   * @param {number} [limit=40] - Maximum number of children to return per page
   * @param {boolean} [flat=false] - When true, returns all row items as a flat list bypassing grouping
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public queryTableAsTree(
    {
      tableId,
      groupKeys,
      offset,
      limit,
      flat
    } : {
      tableId: string,
      groupKeys?: Array<string>,
      offset?: number,
      limit?: number,
      flat?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (tableId === null || tableId === undefined) {
      throw new Error("'tableId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/tables/${encodeURIComponent(String(tableId))}/tree`
      .replace('{tableId}', encodeURIComponent(String(tableId)));
    const urlTemplate = `${baseUrl}/tables/{tableId}/tree`;

    const queryParams = {
      ['groupKeys']: groupKeys,      ['offset']: offset,      ['limit']: limit,      ['flat']: flat
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.TreeDataOutputV1>;
  }

  /**
   * @summary Query table data with filters and advanced options
   * @param {string} tableId - ID of the table
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public queryTableData(
    body: models.TableDataQueryInputV1,
    {
      tableId
    } : {
      tableId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (tableId === null || tableId === undefined) {
      throw new Error("'tableId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/tables/${encodeURIComponent(String(tableId))}/data`
      .replace('{tableId}', encodeURIComponent(String(tableId)));
    const urlTemplate = `${baseUrl}/tables/{tableId}/data`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TableResultOutputV1>;
  }

}


export const sqTablesApi = new sqTablesApiClass();

export type sqTablesApiEndpoints = {
  'exportTableDataCsv': {
    method: 'post';
    path: '/tables/${encodeURIComponent(String(tableId))}/data/csv';
    response: {};
  };
  'exportTableDataXlsx': {
    method: 'post';
    path: '/tables/${encodeURIComponent(String(tableId))}/data/xlsx';
    response: {};
  };
  'queryCapsulesTable': {
    method: 'post';
    path: '/tables/capsules';
    response: models.TableResultOutputV1;
  };
  'queryConditionTable': {
    method: 'post';
    path: '/tables/condition';
    response: models.TableResultOutputV1;
  };
  'querySimpleTable': {
    method: 'post';
    path: '/tables/simple';
    response: models.TableResultOutputV1;
  };
  'queryTableAsTree': {
    method: 'get';
    path: '/tables/${encodeURIComponent(String(tableId))}/tree';
    response: models.TreeDataOutputV1;
  };
  'queryTableData': {
    method: 'post';
    path: '/tables/${encodeURIComponent(String(tableId))}/data';
    response: models.TableResultOutputV1;
  };
};

type ApiExportTableDataCsvResponse = {};
type ApiexportTableDataCsvMutationParams = Parameters<typeof sqTablesApi.exportTableDataCsv> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTablesApi.exportTableDataCsv>;

export function useApiExportTableDataCsvMutation(
  options?: Omit<UseMutationOptions<ApiExportTableDataCsvResponse, AxiosError<SeeqErrorData>,
    ApiexportTableDataCsvMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiExportTableDataCsvResponse, AxiosError<SeeqErrorData>,
  ApiexportTableDataCsvMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiexportTableDataCsvMutationParams) =>
      sqTablesApi.exportTableDataCsv(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiExportTableDataXlsxResponse = {};
type ApiexportTableDataXlsxMutationParams = Parameters<typeof sqTablesApi.exportTableDataXlsx> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTablesApi.exportTableDataXlsx>;

export function useApiExportTableDataXlsxMutation(
  options?: Omit<UseMutationOptions<ApiExportTableDataXlsxResponse, AxiosError<SeeqErrorData>,
    ApiexportTableDataXlsxMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiExportTableDataXlsxResponse, AxiosError<SeeqErrorData>,
  ApiexportTableDataXlsxMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiexportTableDataXlsxMutationParams) =>
      sqTablesApi.exportTableDataXlsx(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiQueryCapsulesTableResponse = models.TableResultOutputV1;
/** Named request inputs; transport overrides do not identify cached data. */
type ApiQueryCapsulesTableQueryParams = {
  body: models.CapsulesTableInputV1;
};

/** Omit inputs or individual fields to match multiple cached requests during invalidation. */
type ApiQueryCapsulesTableQueryKeyParams = {
  [K in keyof ApiQueryCapsulesTableQueryParams]?: Partial<ApiQueryCapsulesTableQueryParams[K]>;
};

export function QueryCapsulesTableQueryKey(input: ApiQueryCapsulesTableQueryKeyParams) {
  return ['sqTablesApi', 'queryCapsulesTable', input] as const;
}

/** A safe, idempotent read transported as POST. The cache stores the unmodified SDK response payload. */
export function useApiQueryCapsulesTableQuery<TData = ApiQueryCapsulesTableResponse>(
  input: ApiQueryCapsulesTableQueryParams,
  options?: Omit<UseQueryOptions<ApiQueryCapsulesTableResponse, AxiosError<SeeqErrorData>, TData>, 'queryKey' | 'queryFn'> & {
    axiosInstance?: AxiosInstance;
    silent?: boolean;
  },
): UseQueryResult<TData, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: QueryCapsulesTableQueryKey(input),
    queryFn: () => sqTablesApi.queryCapsulesTable(
      input.body,
      
      
      requestConfig,
    ).then((response) => response.data),
    ...queryOptions,
  });
}
type ApiqueryCapsulesTableMutationParams = Parameters<typeof sqTablesApi.queryCapsulesTable> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTablesApi.queryCapsulesTable>;
type ApiqueryCapsulesTableMutationVariables = models.CapsulesTableInputV1;

export function useApiQueryCapsulesTableMutation(
  options?: Omit<UseMutationOptions<ApiQueryCapsulesTableResponse, AxiosError<SeeqErrorData>,
    ApiqueryCapsulesTableMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiQueryCapsulesTableResponse, AxiosError<SeeqErrorData>,
  ApiqueryCapsulesTableMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApiqueryCapsulesTableMutationVariables) =>
      sqTablesApi.queryCapsulesTable(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiQueryConditionTableResponse = models.TableResultOutputV1;
type ApiqueryConditionTableMutationParams = Parameters<typeof sqTablesApi.queryConditionTable> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTablesApi.queryConditionTable>;
type ApiqueryConditionTableMutationVariables = models.ConditionTableInputV1;

export function useApiQueryConditionTableMutation(
  options?: Omit<UseMutationOptions<ApiQueryConditionTableResponse, AxiosError<SeeqErrorData>,
    ApiqueryConditionTableMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiQueryConditionTableResponse, AxiosError<SeeqErrorData>,
  ApiqueryConditionTableMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApiqueryConditionTableMutationVariables) =>
      sqTablesApi.queryConditionTable(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiQuerySimpleTableResponse = models.TableResultOutputV1;
type ApiquerySimpleTableMutationParams = Parameters<typeof sqTablesApi.querySimpleTable> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTablesApi.querySimpleTable>;
type ApiquerySimpleTableMutationVariables = models.SimpleTableInputV1;

export function useApiQuerySimpleTableMutation(
  options?: Omit<UseMutationOptions<ApiQuerySimpleTableResponse, AxiosError<SeeqErrorData>,
    ApiquerySimpleTableMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiQuerySimpleTableResponse, AxiosError<SeeqErrorData>,
  ApiquerySimpleTableMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApiquerySimpleTableMutationVariables) =>
      sqTablesApi.querySimpleTable(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiQueryTableAsTreeResponse = models.TreeDataOutputV1;
export function QueryTableAsTreeQueryKey(
  params: Parameters<typeof sqTablesApi.queryTableAsTree>[0],
) {
  return ['sqTablesApi', 'queryTableAsTree', params] as const;
}

export function useApiQueryTableAsTreeQuery(
  params: Parameters<typeof sqTablesApi.queryTableAsTree>[0],
  options?: Omit<UseQueryOptions<ApiQueryTableAsTreeResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiQueryTableAsTreeResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: QueryTableAsTreeQueryKey(params),
    queryFn: () =>
      sqTablesApi.queryTableAsTree(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiQueryTableDataResponse = models.TableResultOutputV1;
/** Named request inputs; transport overrides do not identify cached data. */
type ApiQueryTableDataQueryParams = {
  body: models.TableDataQueryInputV1;
  params: Parameters<typeof sqTablesApi.queryTableData>[1];
};

/** Omit inputs or individual fields to match multiple cached requests during invalidation. */
type ApiQueryTableDataQueryKeyParams = {
  [K in keyof ApiQueryTableDataQueryParams]?: Partial<ApiQueryTableDataQueryParams[K]>;
};

export function QueryTableDataQueryKey(input: ApiQueryTableDataQueryKeyParams) {
  return ['sqTablesApi', 'queryTableData', input] as const;
}

/** A safe, idempotent read transported as POST. The cache stores the unmodified SDK response payload. */
export function useApiQueryTableDataQuery<TData = ApiQueryTableDataResponse>(
  input: ApiQueryTableDataQueryParams,
  options?: Omit<UseQueryOptions<ApiQueryTableDataResponse, AxiosError<SeeqErrorData>, TData>, 'queryKey' | 'queryFn'> & {
    axiosInstance?: AxiosInstance;
    silent?: boolean;
  },
): UseQueryResult<TData, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: QueryTableDataQueryKey(input),
    queryFn: () => sqTablesApi.queryTableData(
      input.body,
      input.params,
      
      requestConfig,
    ).then((response) => response.data),
    ...queryOptions,
  });
}
type ApiqueryTableDataMutationParams = Parameters<typeof sqTablesApi.queryTableData> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTablesApi.queryTableData>;

export function useApiQueryTableDataMutation(
  options?: Omit<UseMutationOptions<ApiQueryTableDataResponse, AxiosError<SeeqErrorData>,
    ApiqueryTableDataMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiQueryTableDataResponse, AxiosError<SeeqErrorData>,
  ApiqueryTableDataMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiqueryTableDataMutationParams) =>
      sqTablesApi.queryTableData(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
